export var getPolarOptions = function getPolarOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultOptions = {
    startAngle: -Math.PI / 2,
    endAngle: Math.PI * 3 / 2,
    innerRadius: 0,
    outerRadius: 1
  };
  return Object.assign(Object.assign({}, defaultOptions), options);
};
/**
 * Polar transformation for circular charts using center of canvas as origin.
 * @todo Adjust size of canvas by startAngle and endAngle to make chart as big as possible.
 */
export var Polar = function Polar(options) {
  var _getPolarOptions = getPolarOptions(options),
    startAngle = _getPolarOptions.startAngle,
    endAngle = _getPolarOptions.endAngle,
    innerRadius = _getPolarOptions.innerRadius,
    outerRadius = _getPolarOptions.outerRadius;
  return [['translate', 0, 0.5], ['reflect.y'], ['translate', 0, -0.5], ['polar', startAngle, endAngle, innerRadius, outerRadius]];
};
Polar.props = {};